/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Body_5Inputs */

const en_wb_sales_body_5 = /** @type {(inputs: Wb_Sales_Body_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best,`)
};

const lv_wb_sales_body_5 = /** @type {(inputs: Wb_Sales_Body_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar cieņu,`)
};

/**
* | output |
* | --- |
* | "Best," |
*
* @param {Wb_Sales_Body_5Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_body_5 = /** @type {((inputs?: Wb_Sales_Body_5Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Body_5Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_body_5(inputs)
	return en_wb_sales_body_5(inputs)
});